import { api } from 'app/utils/api/helpers'

export const listBackgroundChecks = (teamId, params) => {
  return api.get(`/sm/team/${teamId}/backgroundcheck/report`, { params })
}
